import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DepotStockLocationsComponent } from './pages/depot-stock-locations/depot-stock-locations.component';
import { DepotStockLocationsNewComponent } from './pages/depot-stock-locations-new/depot-stock-locations-new.component';
import { DepotStockLocationsEditComponent } from './pages/depot-stock-locations-edit/depot-stock-locations-edit.component';
import { AuthGuard } from '../auth/guards/auth.guard';

const routes: Routes = [
  {
    path: 'workshop/depot-stock-locations',
    component: DepotStockLocationsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'workshop/depot-stock-locations/new',
    component: DepotStockLocationsNewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'workshop/depot-stock-locations/edit/:id',
    component: DepotStockLocationsEditComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DepotStockLocationRoutingModule { }
